module.exports = __webpack_public_path__ + "img/7.a590685a.jpg";